
import Vue from 'vue';
import * as commonConst from '../common/constants';
import * as startTempConst from './constants';
import * as servicesApis from '../../services/apis/launchTemplate';

export default {
    [startTempConst.startTempList](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, servicesApis.startTempList);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(startTempConst.startTempList, {
                    list: data.ModelSet,
                    total: data.InstanceCount
                });
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [startTempConst.deleteStartTemp](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, servicesApis.deleteStartTemp);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //修改实例启动模板
    [startTempConst.modifyModel](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, servicesApis.modifyModel);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                // ctx.commit(startTempConst.modifyModel, data);
                resolve(data);
            }).catch(e => {
                // ctx.commit(startTempConst.modifyModel, e);
                reject(e);
            });
        });
    },
};

